var buildFollowSellerEvent = function buildFollowSellerEvent(isFollowing, sellerId) {
  return {
    content_id: isFollowing ? 'seguir' : 'nao-seguir',
    content_type: "chat-lojista:".concat(sellerId),
    event: 'select_content',
    mini_app_name: 'fale-lojista'
  };
};
export var clickFollowSellerEvent = function clickFollowSellerEvent(_ref) {
  var isFollowing = _ref.isFollowing,
    sellerId = _ref.sellerId;
  return buildFollowSellerEvent(isFollowing, sellerId);
};